module.exports = __webpack_public_path__ + "img/undertakingCases6.a49751b6.jpg";